(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
$(document).ready(function() {
  $('.custom-tips input').on('input', function() {
    const unit = $('[name="properties[Measurement Unit]"]:checked').val() || inch;
    const dreassBust = $('[name="properties[Bust]').val() || 0;
    const dreassWaist = $('[name="properties[Waist]"]').val() || 0;
    const dreassHips = $('[name="properties[Hips]"]').val() || 0;
    const dreassHollow = $('[name="properties[Hollow to Floor]"]').val() || 0;
    const dreassHeight = $('[name="properties[Height]"]').val() || 0;
    let measurements = [];
    if(unit == 'inch') {
      if(dreassBust != 0) measurements.push({"inch": dreassBust, "cm": (dreassBust * 2.54).toFixed(2), "name": "Bust"});
      if(dreassWaist != 0) measurements.push({"inch": dreassWaist, "cm": (dreassWaist * 2.54).toFixed(2), "name": "Waist"});
      if(dreassHips != 0) measurements.push({"inch": dreassHips, "cm": (dreassHips * 2.54).toFixed(2), "name": "Hips"});
      if(dreassHollow != 0) measurements.push({"inch": dreassHollow, "cm": (dreassHollow * 2.54).toFixed(2), "name": "Hollow to Floor"});
      if(dreassHeight != 0) measurements.push({"inch": dreassHeight, "cm": (dreassHeight * 2.54).toFixed(2), "name": "Height"});
    } else {
      if(dreassBust != 0) measurements.push({"inch": (dreassBust * 0.393701).toFixed(2), "cm": dreassBust, "name": "Bust"});
      if(dreassWaist != 0) measurements.push({"inch": (dreassWaist * 0.393701).toFixed(2), "cm": dreassWaist, "name": "Waist"});
      if(dreassHips != 0) measurements.push({"inch": (dreassHips * 0.393701).toFixed(2), "cm": dreassHips, "name": "Hips"});
      if(dreassHollow != 0) measurements.push({"inch": (dreassHollow * 0.393701).toFixed(2), "cm": dreassHollow, "name": "Hollow to Floor"});
      if(dreassHeight != 0) measurements.push({"inch": (dreassHeight * 0.393701).toFixed(2), "cm": dreassHeight, "name": "Height"});
    }

    // measurementTable(measurements)
  })

  $('.customColorPicker').on('input', function() {
    $(this).parents('.variations').find('#customColorProperty').val($(this).data('value').trim().replace(/\b[a-z]/g, (x) => x.toUpperCase()))
  })

  $('.variations input').on('input', function() {
    if($('[name="color"][value="Custom Color"]').is(":checked") != true) $('.customColorListContainer input').removeAttr('checked');
    $(this).parents('.selector-wrapper').find('select').val($(this).val())
    const event = new Event("change", {
      view: window
    });
    document.getElementById($(this).parents('.selector-wrapper').find('select').attr('id')).dispatchEvent(event);
  })

  function measurementTable(measurements) {
    $('.measurementTable').html('');
    if(measurements.length > 0) {
      $('.measurementTable').append('<table><thead><tr><th><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg> INCH</th><th><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg> CM</th></tr></thead><tbody></tbody></table>')
      measurements.forEach(function(measurement) {
        $('.measurementTable').find('tbody').append('<tr><td>' + measurement.name + ': ' + measurement.inch + '</td><td>' + measurement.name + ': ' + measurement.cm + '</td></tr>')
      })
    }
  }
})

  } catch(e) { console.error(e); }
})();
})();
